var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 0-192.529 256 192.529 256c141.385 0 256-114.615 256-256s-114.615-256-256-256z",
    fill: "#ffd959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 256c0 141.385 114.615 256 256 256v-512c-141.385 0-256 114.615-256 256z",
    fill: "#ffeaa6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 181h30v30h-30z",
    fill: "#ffd959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 181h30v30h-30z",
    fill: "#ffc40f",
    transform: "matrix(-1 0 0 -1 814 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293 121v60c0 16.569 13.431 30 30 30s30-13.431 30-30v-60c0-16.569-13.431-30-30-30s-30 13.431-30 30z",
    fill: "#414851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219 121v60c0 16.569-13.431 30-30 30s-30-13.431-30-30v-60c0-16.569 13.431-30 30-30s30 13.431 30 30z",
    fill: "#62676f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.816 316c7.217-18.61 11.184-38.841 11.184-60h-166l-60 120z",
    fill: "#fff7e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 256h-166c0 21.159 3.967 41.39 11.184 60l154.816 60z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 316-60 53 60 53c70.52 0 130.761-43.978 154.816-106z",
    fill: "#ff5253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.184 316c24.055 62.022 84.296 106 154.816 106v-106z",
    fill: "#ff7b6b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.cfc65af9103f21e608d22591e93a6360.svg";
export { ForwardRef as ReactComponent };